class ProductCard {

    constructor(card) {
        this.card = card

        this.type = card.dataset.cardType || "default"
        this.collection = card.dataset.collection || ""

        this.variantsBox = card.querySelector(".svc-card__variants")
        this.subproductsBox = card.querySelector(".svc-card__subproducts")
        this.subproducts = card.querySelectorAll(".svc-card__subproduct")
        this.currentSubName = card.querySelector(".svc-card__subproduct-name")
        this.currentSubPrice = card.querySelector(".svc-card__subproduct-price")
        this.priceBox = card.querySelector(".svc-card__price--2")
        this.form = card.querySelector(".svc-card__form")

        this.productTitle = card.querySelector(".svc-card__title").textContent
        if (this.type === "instant") {
            this.headerTitle = card.querySelector(".svc-card__screen--3 .svc-card__header-title")
        } else {
            this.headerTitle = card.querySelector(".svc-card__screen--2 .svc-card__header-title")
        }

        this.currentVariants = []
        this.currentVariant = null

        this.init()
    }

    init() {

        this.setScreen(1)

        if (this.headerTitle) {
            this.headerTitle.textContent = this.productTitle
        }
        if (this.type !== "default") {
            this.initSubproductPrices()
        }
        this.initFirstSubproduct()

        if (this.type === "variants") {
            this.card.querySelector(".svc-card__subproduct-select")?.remove()
        }

        if (this.type === "variants" || this.type === "instant") {
            this.initVariantsFromHTML()
        }


        if (this.type === "simple") {
            this.currentVariant = {
                id: this.form.querySelector("[name=id]").value,
                title: this.form.querySelector("[name=variant_title]").value,
                price: this.form.querySelector("[name=price]").value
            }
        }

    }

    initVariantsFromHTML() {

        if (!this.card.dataset.variants) return

        this.currentVariants = JSON.parse(this.card.dataset.variants)

        this.renderVariants()

    }

    setScreen(screen) {

        this.card.classList.remove(
            "is-screen-1",
            "is-screen-2",
            "is-screen-3"
        )

        this.card.classList.add(`is-screen-${screen}`)

    }

    updateTotalPrice() {

        if (!this.currentVariant) return
        if (!this.priceBox) return

        const qtyInput = this.card.querySelector(".svg-card__quantity-input")
        const quantity = parseInt(qtyInput?.value) || 1

        const price = parseFloat(this.currentVariant.price) / 100
        const total = price * quantity

        this.priceBox.textContent = `$${total.toFixed(2)}`
    }

    initFirstSubproduct() {

        if (!this.subproducts.length) return

        const first = this.subproducts[0]

        const title = first.dataset.title
        const variants = JSON.parse(first.dataset.variants)

        first.classList.add("is-active")

        const price = variants[0]?.price || 0

        if (this.currentSubName) {
            this.currentSubName.textContent = title
        }

        if (this.currentSubPrice) {
            this.currentSubPrice.textContent = `$${(price / 100).toFixed(2)}`
        }

        this.currentVariants = variants

        this.renderVariants()

    }

    initSubproductPrices() {

        this.subproducts.forEach(btn => {

            const variants = JSON.parse(btn.dataset.variants || "[]")
            const price = variants[0]?.price || 0

            let priceEl = btn.querySelector(".svc-card__subproduct-price")

            if (!priceEl) {
                priceEl = document.createElement("span")
                priceEl.className = "svc-card__subproduct-price"
                btn.appendChild(priceEl)
            }

            priceEl.textContent = `$${(price / 100).toFixed(2)}`

        })

    }

    selectSubproduct(btn) {

        const title = btn.dataset.title
        const variants = JSON.parse(btn.dataset.variants)

        this.subproducts.forEach(item => {
            item.classList.remove("is-active")
        })

        btn.classList.add("is-active")

        const price = variants[0]?.price || 0

        if (this.currentSubName) {
            this.currentSubName.textContent = title
        }

        if (this.currentSubPrice) {
            this.currentSubPrice.textContent = `$${(price / 100).toFixed(2)}`
        }

        this.currentVariants = variants

        const qtyInput = this.card.querySelector(".svg-card__quantity-input")
        const hidden = this.card.querySelector(".svc-card__form [name=quantity]")

        if (qtyInput) qtyInput.value = 1
        if (hidden) hidden.value = 1

        this.renderVariants()

        this.setScreen(2)

    }

    renderVariants() {

        const isInstant = this.type === "instant"
        const box = isInstant ? this.subproductsBox : this.variantsBox
        if (!box) return

        box.innerHTML = ""
        this.currentVariant = null

        this.currentVariants.forEach((v, index) => {

            let el

            if (isInstant) {

                el = document.createElement("form")
                el.className = "svc-card__subproduct-form"

                el.innerHTML = `
                <input type="hidden" name="id" value="${v.id}">
                <input type="hidden" name="variant_title" value="${v.title}">
                <input type="hidden" name="product_title" value="${this.productTitle}">
                <input type="hidden" name="price" value="${v.price}">
                <input type="hidden" name="quantity" value="1">
                <input type="hidden" name="collection" value="${this.collection}">
                <button type="button" class="svc-card__subproduct add_to_cart_button">
                    <span class="svc-card__subproduct-title">${v.title}</span>
                    <span class="svc-card__subproduct-price">$${(v.price / 100).toFixed(2)}</span>
                </button>
            `

            } else {

                el = document.createElement("button")
                el.type = "button"
                el.className = "svc-card__variant"
                el.textContent = v.title

                el.dataset.id = v.id
                el.dataset.title = v.title
                el.dataset.price = v.price

            }

            if (index === 0) {
                el.classList.add("is-active")
            }

            if (!isInstant && index === 0) {
                this.currentVariant = {
                    id: String(v.id),
                    title: v.title,
                    price: String(v.price)
                }
            }

            box.appendChild(el)

        })

        if (this.currentVariant) {
            this.syncForm()
        }

    }

    selectVariant(btn) {

        this.variantsBox.querySelectorAll(".svc-card__variant").forEach(item => {
            item.classList.remove("is-active")
        })

        btn.classList.add("is-active")

        this.currentVariant = {
            id: btn.dataset.id,
            title: btn.dataset.title,
            price: btn.dataset.price,
            compareAtPrice: btn.dataset.compareAtPrice || ""
        }

        const qtyInput = this.card.querySelector(".svg-card__quantity-input")
        const hidden = this.card.querySelector(".svc-card__form [name=quantity]")

        if (qtyInput) qtyInput.value = 1
        if (hidden) hidden.value = 1

        this.syncForm()

    }

    syncForm() {

        if (!this.form) return

        this.updateTotalPrice()

        this.form.querySelector("[name=id]").value = this.currentVariant.id
        this.form.querySelector("[name=variant_title]").value = this.currentVariant.title
        this.form.querySelector("[name=price]").value = this.currentVariant.price

        const compareField = this.form.querySelector("[name=compare_at_price]")

        if (compareField) {
            compareField.value = this.currentVariant.compareAtPrice || ""
        }

    }

}

class ProductCardManager {

    constructor() {

        this.cards = new Map()

        document.querySelectorAll(".svc-card").forEach(card => {

            const instance = new ProductCard(card)

            this.cards.set(card, instance)

        })

        document.addEventListener("click", this.handleClick.bind(this))

    }

    initCards(root) {
        const cards = root.querySelectorAll(".svc-card")

        cards.forEach(card => {
            if (this.cards.has(card)) return

            const instance = new ProductCard(card)
            this.cards.set(card, instance)
        })
    }


    getCard(el) {

        const cardEl = el.closest(".svc-card")

        if (!cardEl) return null

        return this.cards.get(cardEl)

    }

    handleClick(e) {

        const card = this.getCard(e.target)

        if (!card) return

        if (e.target.closest(".svc-card__choose")) {

            if (card.type === "instant") {
                card.setScreen(3)
            }

            else {
                card.setScreen(2)
            }

        }

        if (e.target.closest(".svc-card__subproduct-select")) {
            card.setScreen(3)
        }

        if (e.target.closest(".svc-card__back")) {

            if (card.type === "instant") {
                card.setScreen(1)
                return
            }

            if (card.card.classList.contains("is-screen-3")) {
                card.setScreen(2)
            } else {
                card.setScreen(1)
            }

        }


        const plusBtn = e.target.closest(".svg-card__quantity-btn--plus")
        const minusBtn = e.target.closest(".svg-card__quantity-btn--minus")

        if (plusBtn || minusBtn) {

            const cardEl = e.target.closest(".svc-card")
            const cardInstance = this.cards.get(cardEl)

            const input = cardEl.querySelector(".svg-card__quantity-input")
            const hidden = cardEl.querySelector(".svc-card__form [name=quantity]")

            let value = parseInt(input.value) || 1

            if (plusBtn) value++
            if (minusBtn) value--

            if (value < 1) value = 1

            input.value = value

            if (hidden) hidden.value = value

            cardInstance.updateTotalPrice()

            return
        }

        const subproduct = e.target.closest(".svc-card__subproduct")

        if (subproduct && card.type !== "instant") {
            card.selectSubproduct(subproduct)
            return
        }

        const buyBtn = e.target.closest(".svc-card__buy")

        if (buyBtn) {

        }

        const variant = card.type === "instant"
            ? e.target.closest(".svc-card__subproduct")
            : e.target.closest(".svc-card__variant")

        if (variant) {

            if (card.type === "instant") {

                const container = card.subproductsBox

                container?.querySelectorAll(".svc-card__subproduct-form").forEach(f => {
                    f.classList.remove("is-active")
                })

                const form = variant.closest("form")
                if (form) form.classList.add("is-active")

                return
            }
            card.selectVariant(variant)

        }

    }

}

window.productCardManager = new ProductCardManager()

document.addEventListener("input", e => {

    const input = e.target.closest(".svg-card__quantity-input")
    if (!input) return

    const card = input.closest(".svc-card")
    const hidden = card.querySelector(".svc-card__form [name=quantity]")

    let value = parseInt(input.value) || 1

    if (value < 1) value = 1

    input.value = value

    if (hidden) hidden.value = value

    const instance = window.productCardManager?.cards.get(card)
    instance?.updateTotalPrice()

})